export default __webpack_public_path__ + "static/media/bci-2-hover.b48d5720.svg";